import { render, staticRenderFns } from "./DescuentosReporteDetalle.vue?vue&type=template&id=6cc6f3d4"
import script from "./DescuentosReporteDetalle.vue?vue&type=script&lang=js"
export * from "./DescuentosReporteDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports